export enum LocalClientTypes {
  localStorage,
  encryptedLocalStorage,
}
